/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Next_Task_NoneInputs */

const en_task_next_task_none = /** @type {(inputs: Task_Next_Task_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No next activity`)
};

const pt_br2_task_next_task_none = /** @type {(inputs: Task_Next_Task_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma próxima atividade`)
};

/**
* | output |
* | --- |
* | "No next activity" |
*
* @param {Task_Next_Task_NoneInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_next_task_none = /** @type {((inputs?: Task_Next_Task_NoneInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Next_Task_NoneInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_next_task_none(inputs)
	return pt_br2_task_next_task_none(inputs)
});